<template>
  <v-container class="pa-10">
    <v-container>
      <div class="text-h5">Novo Teste</div>
      <v-divider />
    </v-container>

    <v-container>
      <v-col class="px-0">
        <v-card>
          <v-row class="px-6" justify="space-between">
            <v-col cols="12" md="6">
              <v-text-field
                label="Nome do teste"
                :placeholder="request.nome"
                v-model="request.nome"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Número de questões"
                v-model="request.qtdQuestoes"
                type="number"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        v-for="especialidade of specialityTheme"
        :key="especialidade.id"
        class="px-0"
      >
        <v-card elevation="5">
          <v-container>
            <div class="text-h7">{{ especialidade.nome }}</div>
            <v-divider />

            <v-container fluid>
              <v-row no-gutters>
                <v-col md="4" sm="12" cols="12">
                  <v-checkbox
                    v-model="especialidade.allSelected"
                    label="Todos"
                    color="indigo darken-3 "
                    hide-details
                    @change="selectAll(especialidade)"
                  ></v-checkbox>
                </v-col>
                <template v-for="tema in especialidade.temas">
                  <v-col :key="tema.idTema" md="4" sm="12" cols="12">
                    <v-checkbox 
                      v-model="request.idTemaList"
                      :label="tema.nome"
                      color="indigo darken-3"
                      :value="tema.idTema"
                      hide-details
                      hint="teste"
                      :disabled="tema.status === 'Inativo'"
                      multiple
                    ></v-checkbox>
                    <p class="subCheckbox">Perguntas respondidadas: {{ tema.questoesRespondidas }} de {{ tema.totalQuestoes }}</p>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>

      <v-col class="px-0">
        <v-card elevation="5">
          <v-container>
            <div class="text-h7">Filtro de questões</div>
            <v-divider />

            <v-container fluid>
              <v-row no-gutters>
                <v-radio-group v-model="request.tipoQuestoes" row>
                  <v-radio
                    v-for="filtro in lstFiltroQuestoes"
                    :key="filtro.id"
                    :label="filtro.nome"
                    color="indigo darken-3"
                    :value="filtro.codigo"
                    hide-details
                  ></v-radio>
                </v-radio-group>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
      .
      <v-row justify="center" no-gutters>
        <v-dialog v-model="dialog" max-width="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              x-large
              class="col-12 .col-md-4"
              color="indigo darken-0 white--text"
              v-bind="attrs"
              v-on="on"
              :disabled="validaCamposQuestao()"
              >GERAR TESTE</v-btn
            >
          </template>
          <v-card>
            <v-card-title class="headline">
              Escolha o modo do simulado
            </v-card-title>

            <v-card-text
              >O modo padrão simula uma prova real e você só poderá ver o
              resultado no final do teste, já no modo tutor a cada pergunta
              respondida, o tempo será pausado para que você possa ler as
              explicações de cada resposta.</v-card-text
            >
            <v-card-actions justify-center>
              <v-spacer></v-spacer>
              <v-btn text color="indigo darken-3" @click="gerarTeste(0)"
                >MODO PADRÃO</v-btn
              >
              <v-btn text color="indigo darken-3" @click="gerarTeste(1)"
                >MODO TUTOR</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-container>
</template>
<script>
import { mapActions, mapState } from "vuex";

export default {
  data: () => ({
    lstFiltroQuestoes: [
        { id: "QUALQUER", codigo: 0, nome: "Todas as questões" },
        { id: "NUNCA", codigo: 1, nome: "Questões não respondidas" },
        { id: "ERRADAS", codigo: 3, nome: "Questões respondidas erradas" },
        { id: "FAVORITAS", codigo: 4, nome: "Questões favoritadas" },
        { id: "REALIZADO", codigo: 2, nome: "Questões já realizadas" }
    ],
    teste: "",
    dialog: false,
    request: {
      idTemaList: [],
      modoTeste: "",
      nome: "",
      qtdQuestoes: "10",
      tipoQuestoes: 0,
    },
  }),

  computed: {
    ...mapState("specialty", ["specialityTheme"]),
  },

  created() {
    this.preencheNomeTeste();
    this.initialize();
  },
  watch: {},
  methods: {
    ...mapActions("specialty", ["getSpecialtyTheme"]),
    async initialize() {
      await this.getSpecialtyTheme();

    },
    preencheNomeTeste() {
      var data = new Date();
      this.request.nome =
        "Simulado - " +
        data.getDate() +
        "/" +
        (data.getMonth() + 1) +
        "/" +
        data.getFullYear() +
        " " +
        data.getHours() +
        "Hrs";
    },
    selectAll(especialidade) {
      if (especialidade.allSelected) {
        for (let tema in especialidade.temas) {
          this.request.idTemaList.push(especialidade.temas[tema].idTema);
        }
      } else {
        for (let t in especialidade.temas) {
          this.request.idTemaList.splice(
            especialidade.temas.indexOf(especialidade.temas[t].idTema),
            1
          );
        }
      }
    },
    ...mapActions("test", ["createTest"]),
    async gerarTeste(modoTeste) {
      this.request.modoTeste = modoTeste;
      const resp = await this.createTest(this.request);
      this.$router.push({
        name: "novoTesteModo",
        params: { teste: resp.data.idTeste },
      });
    },
    validaCamposQuestao() {
      return (
        this.request.nome === "" ||
        this.request.qtdQuestoes === "" ||
        this.request.tipoQuestoes === "" ||
        this.request.idTemaList.length === 0
      );
    },
  },
};
</script>
<style scoped>
  .subCheckbox{
    color: gray;
    margin-left: 30px;
    font-size: 12px;
  }
</style>